import { useStorage } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

export const useStorageReward = () => {
  const { rewards } = useSettings();
  const [storageRewardId, { set: setStorageRewardId }] = useStorage<
    string | undefined
  >('winningRewardId', undefined);

  const currentReward = storageRewardId
    ? rewards.find(({ id }) => id === storageRewardId)
    : undefined;

  return {
    reward: currentReward,
    setStorageRewardId
  };
};
